export const hasBoundarySpace = (value) =>
  typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '));

export const getBoundarySpaceNameError = (nameType, name) => {
  const safeName = typeof name === 'string' ? name : '';
  if (safeName.startsWith(' ') && safeName.endsWith(' ')) {
    return `${nameType} "${safeName}" is starting and ending with a space. Starting or ending spaces are not allowed.`;
  }
  if (safeName.startsWith(' ')) {
    return `${nameType} "${safeName}" is starting with a space. Starting spaces are not allowed.`;
  }
  return `${nameType} "${safeName}" is ending with a space. Ending spaces are not allowed.`;
};

export const findBoundarySpaceName = (items = [], fieldName, nameType) => {
  const invalidItem = (items || []).find((item) => hasBoundarySpace(item?.[fieldName]));
  if (!invalidItem) return null;
  return getBoundarySpaceNameError(nameType, invalidItem[fieldName]);
};
